import _ from 'lodash'
import api from '../../api'
import * as types from '../../types'

export default {
  state: {
    initData: {},
    confirmLoanModal: {
      show: false,
      data: {}
    }
  },
  getters: {
    [types.GET_STEP1_INITIAL_STATE]: state => state.initData,
    [types.GET_CONFIRM_LOAN_DATA_STATE]: state => state.confirmLoanModal
  },
  actions: {
    [types.GET_STEP1_INITIAL_DATA]: ({dispatch, commit}, params) => api.getStep1InitialData({
      token: params.token,
      productId: params.productId
    }).then((res) => {
      const resData = res.data
      if (Number(resData.code) === 0) {
        commit(types.SET_STEP1_INITIAL_DATA, resData.data)
        commit(types.SET_CONTRACT_STATE, {
          title: '贷款协议',
          show: false,
          content: resData.data.loanAgreement
        })
      } else if (Number(resData.code) === 999) {
        dispatch(types.SET_FAIL_MESSAGE, {
          show: true,
          content: resData.result
        })
        commit(types.SET_USER, {})
        params.router.push('/login')
      } else {
        dispatch(types.SET_FAIL_MESSAGE, {
          show: true,
          content: resData.result || '贷款信息获取失败'
        })
      }
    }),
    [types.GET_SAVED_STEP1_DATA] ({dispatch, commit}, params) {
      return api.getSavedStep1Data({
        token: params.token,
        frontApplyId: params.id
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          const result = resData.data
          commit(types.SET_STEP1_INITIAL_DATA, {
            loanProductList: result.prolist,
            maxValue: result.maxValue,
            minValue: result.minValue,
            repayTypeList: result.repaylist
          })
          commit(types.SET_CONTRACT_STATE, {
            title: '贷款协议',
            show: false,
            content: result.loanAgreement
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '贷款信息获取失败'
          })
        }
        return res
      })
    },
    [types.GET_CONFIRM_LOAN_DATA] ({dispatch, commit}, params) {
      api.getConfirmLoanData({
        token: params.token,
        productId: params.productId,
        repayType: params.repayType,
        money: params.money,
        expires: params.expires,
        expiresUnit: params.expiresUnit
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_CONFIRM_LOAN_DATA, {
            show: true,
            data: {
              params: {
                productId: params.productId,
                productName: params.productName,
                repayType: params.repayType,
                repayTypeName: params.repayTypeName,
                money: params.money,
                expires: params.expires
              },
              resData: resData.data
            }
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '贷款明细获取错误'
          })
        }
      })
    },
    [types.SAVE_STEP1_DATA] ({dispatch, commit}, params) {
      return api.saveStep1FormData({
        token: params.token,
        customerType: params.customerType,
        money: params.money,
        expires: params.expires,
        expiresUnit: params.expiresUnit,
        repayType: params.repayType,
        productName: params.productName,
        productId: params.productId
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          // dispatch(types.SET_SUCCESS_MESSAGE, {
          //   show: true,
          //   content: resData.result
          // })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '贷款信息保存错误'
          })
        }
        // code = 0时候的跳转不在这里处理
        return res
      })
    },
    [types.SAVE_APPLY_LOAN_PROGRESS] ({dispatch, commit}, params) {
      return api.saveApplyLoanProgress({
        token: params.token,
        step: `f${params.step}`,
        frontApplyId: params.id,
        money: params.money,
        expires: params.expires,
        expiresUnit: params.expiresUnit,
        repayType: params.repayType,
        productName: params.productName,
        productId: params.productId,
        bankAccountId: params.bankAccountId,
        gid: params.gid
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          // dispatch(types.SET_SUCCESS_MESSAGE, {
          //   show: true,
          //   content: resData.result
          // })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '贷款进度保存错误'
          })
        }
        return res
      })
    }
  },
  mutations: {
    [types.SET_STEP1_INITIAL_DATA] (state, data) {
      data.repayTypeList.forEach((item) => {
        if (['1', '2'].indexOf(item.baseProductRepay) !== -1) {
          item.unitValue = '2'
          item.unitText = '月'
        } else {
          item.unitValue = '3'
          item.unitText = '天'
        }
      })
      state.initData = data
    },
    [types.SET_STEP1_INITIAL_DATA_REPAY_TYPE] (state, data) {
      state.initData.repayTypeList = data
      // /.repayTypeList
    },
    [types.SET_CONFIRM_LOAN_DATA] (state, data) {
      state.confirmLoanModal = {
        show: data.show,
        data: _.isEmpty(data.data) ? state.confirmLoanModal.data : Object.assign({}, data.data.params, data.data.resData)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/applyLoan/step1.js